// str — i18n-Helper für den Vite-Code. Wrappt das Legacy-`topo.str()` über die bestehende Bridge.
//
// ⚠️ INTERIM / Branch-Koordination: Das ausgereifte JS-i18n-Modul (TranslationStore/Core, `ModuleJS.i18n`,
//    `topo.str`-Brücke mit eigener Fallback-Kette + KEY_EMPTY-Marker) lebt im Translation-Branch (Plan
//    `translation-system-analysis.md`, Phase 6/7) und ist HIER noch nicht gemerged. Auf diesem Branch ist
//    `topo.str` die einfache Version (eine Sprache, key-Fallback) → dieser Helper ergänzt die Kette manuell.
//    BEIM MERGE des Translation-Branches: diesen Helper auf `ModuleJS.i18n.translate()` umstellen ODER entfernen
//    (sonst doppelte Kette / KEY_EMPTY-Fehlinterpretation). Aufrufer (`str('KEY')`) können bleiben.
//
// Fallback-Kette: gewählte Sprache → Englisch → Deutsch → Key (IF_STRING).
// `topo.str(key, lang)` liest `topo.t[key][lang]` und gibt bei FEHLENDEM Eintrag den `key` selbst zurück. Diese
// Funktion probiert die Stufen der Reihe nach: zuerst die gewählte Sprache (topoLanguage), dann Englisch, dann
// Deutsch; ist der Key in keiner Sprache gepflegt, bleibt der Key sichtbar (Signal „IF_STRING fehlt noch").
import { TopoGlobalObjectsConnector } from "../legacy_bridge/TopoGlobalObjectsConnector.js";

export function str(key) {
    const topo = TopoGlobalObjectsConnector.GetBasicJSTopoObject();
    if (!topo || typeof topo.str !== 'function') { return key; }

    const selected = topo.str(key);        // gewählte Sprache (nutzt intern topoLanguage)
    if (selected !== key) { return selected; }
    const en = topo.str(key, 'en');
    if (en !== key) { return en; }
    const de = topo.str(key, 'de');
    if (de !== key) { return de; }
    return key;
}
